import {Mapper} from '@s-ui/domain'

import {VehicleDataListValueObject} from '../ValueObjects/VehicleDataListValueObject.js'

export class FromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper extends Mapper {
  constructor({config, vehicleHistoryValueObjectFactory}) {
    super()
    this._config = config
    this._carfaxProviderUrl = this._config.get('CARFAX_PROVIDER_URL')
    this._sourceAppName = this._config.get('SITE_NAME')
    this._vehicleHistoryValueObjectFactory = vehicleHistoryValueObjectFactory
  }

  setParams = ({hasReport, reportUrl, sellerType, vehicleData}) => {
    this._hasReport = hasReport
    this._reportUrl = reportUrl
    this._sellerType = sellerType
    this._vehicleData = vehicleData
    return this
  }

  _getProviderUrl = ({reportUrl}) => {
    if (!reportUrl) return ''
    return `${reportUrl}${this._carfaxProviderUrl
      .replace('%{sourceAppName}', this._sourceAppName)
      .replace('%{sellerType}', this._sellerType)}`
  }

  map = () => {
    return this._vehicleHistoryValueObjectFactory({
      hasReport: this._hasReport,
      reportUrl: this._hasReport ? this._reportUrl : this._getProviderUrl({reportUrl: this._reportUrl}),
      ...(this._hasReport && {verifiedData: VehicleDataListValueObject.createFromApi({value: this._vehicleData})})
    })
  }
}
